import {TypedModalActionTypes} from '../../constants/actionType';

const initialState = {
  isShown: false,
  modalType: undefined,
  data: {},
};

export default function typedModalReducer(state = initialState, action = '') {
  switch (action.type) {
    case TypedModalActionTypes.SHOW_TYPED_MODAL:
      return {...state, isShown: true, modalType: action.modalType, data: action.data};
    case TypedModalActionTypes.SET_MODAL_DATA:
      return {...state, data: action.data};
    case TypedModalActionTypes.HIDE_TYPED_MODAL:
      return action.isResetState ? initialState : {...state, isShown: false};
    default:
      return state;
  }
}
